<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
table td input {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  border: none;
  box-sizing: border-box;
  background: none;
  text-align: center;
}
table td {
  position: relative;
}
/* .table {
  width: 150% !important
} */
</style>
<template>
  
    <CCardBody>
      <CRow>
        <CCol lg="2">
          <div class="form-group">
            <label for="dd-filter-tahun" class="font-weight-bold">Pilih Tahun</label>
            <select class="form-control" name id="dd-filter-tahun" @change="pilihTahun">
              <option value="" selected>Pilih Tahun</option>
              <option v-for="(value, index) in dataTahun" :key="index" :value="value">{{ value }}</option>
            </select>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id @change="changePageSize">
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              v-model="search"
              placeholder="Cari Data ..."
            />
          </div>
        </div>
      </CRow>
      <CRow>
          <CCol lg="12" class="table-responsive">
            <CDataTable style="width: 150% !important" responsive="xl" :items="items" :fields="fields" hover sorter>
              <template #no="{index}">
                <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
              </template>
              <template #flyer="{item}">
                <td class="py-2">
                  
                  <img :src=" baseUrl+ '/files?filename=' + item.flyer + '&path=pelatihan@flyer'" style="height:80px; width:80px;" class=" img img-responsive elevation-2 border" alt="User Picture" @error="imgError" />
                </td>
                
              </template>
               <template #kode_pelatihan="{item}">
                <td class="py-2 font-weight-bold">{{ item.kode_pelatihan ? item.kode_pelatihan : '-' }}</td>
              </template>
              <template #no_lapor="{item}">
                <td class="py-2 font-weight-bold">{{ item.no_laporppl ? item.no_laporppl : '-' }}</td>
              </template>
              <template #email="{item}">
                <td v-if="item.email == null"> - </td>
                <td class="py-2 font-weight-bold">{{ item.email ? item.email : '-' }}</td>
              </template>
               <template #nama_ppl="{item}">
                <td class="py-2">{{ item.nama_pelatihan ? item.nama_pelatihan : '-' }}</td>
              </template>
              <template #tgl_pelaksanaan="{item}">
                <td class="py-2 font-weight-bold text-nowrap"><br>{{ item.tanggal_awal ? item.tanggal_awal : '-' }} s/d  {{ item.tanggal_akhir ? item.tanggal_akhir : '-' }}</td>
              </template>
              <template #skp_terstruktur="{item}">
                <td class="py-2 text-center">{{ item.skp_terstruktur }}</td>
              </template>
              <template #skp_non_terstruktur="{item}">
                <td class="py-2 text-center">{{ item.skp_non_terstruktur }}</td>
              </template>
              <template #assessment="{item}">
                <td class="py-2 text-center">{{ item.assessment ? item.assessment : 0 }}</td>
              </template>
              <template #_status="{item}">
                <td class="py-2 text-center">
                  <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                  <font-awesome-icon icon="times" class="text-danger" v-else />
                </td>
              </template>
              <template #aksi="{item, index}">
                <td class="py-2 d-flex align-items-center">
                    <template v-if="role_status && role_status.status_read">
                    <CButton color="warning" class="text-white btn-sm mr-2" square v-c-tooltip="'Hasil Post Test'" @click="$router.push('/pelatihan/daftar-pelatihan/hasil-post-test/'+item.id_workshop_pelatihan)">
                      <font-awesome-icon icon="paste" />
                    </CButton>
                    <CButton 
                      style="display:none"
                      v-c-tooltip="'Detail'" 
                      color="success" 
                      class="btn-sm mr-2" 
                      @click="lihatDetail(item)"
                      square>
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    </CButton>
                    </template>
                    <template v-if="role_status && role_status.status_update">
                    <router-link v-c-tooltip="'Ubah'" :to="'/pelatihan/daftar-pelatihan/webinar/edit/'+item.id_workshop_pelatihan">
                      <CButton color="info" class="btn-sm mr-2" square>
                        <font-awesome-icon icon="edit" />
                      </CButton>
                    </router-link>
                    <CButton color="success" class="btn-sm mr-2" square v-c-tooltip="'Upload Soal'" @click="$router.push('/pelatihan/daftar-pelatihan/soal-post-test/'+item.id_workshop_pelatihan)">
                      <font-awesome-icon icon="file" />
                    </CButton>
                    <router-link v-c-tooltip="'Pengaturan Sertifikat'" :to="'/pelatihan/daftar-pelatihan/webinar/pengaturan-sertifikat/'+item.id_workshop_pelatihan">
                      <CButton color="primary" class="btn-sm mr-2" square>
                        <font-awesome-icon icon="id-card" />
                      </CButton>
                    </router-link>
                    </template>
                    <template v-if="role_status && role_status.status_delete">
                    <CButton v-c-tooltip="'Hapus'" color="danger" class="btn-sm" square @click="deleteData(item, index)">
                      <font-awesome-icon icon="trash" />
                    </CButton>
                    </template>
                </td>
              </template>
            </CDataTable>
          </CCol>
            <CPagination
              style="float:right"
              class="mt-4 ml-auto"
              :active-page.sync="currentPage"
              :pages="pagination.totalPages"
              responsive
              @click="pageChange"
            />
      </CRow>
      <!-- Modal detail -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="modal-body">
              <div class="d-block">
                <h5>Kode</h5>
                <p class="ml-3 text-muted">W-01</p>
              </div>
              <div class="d-block">
                <h5>Nama Pelatihan</h5>
                <p class="ml-3 text-muted">Tax Review Dan Pelatihan Akuntan</p>
              </div>
              <div class="d-block">
                <h5>Pengelola</h5>
                <p class="ml-3 text-muted">IAPI</p>
              </div>
              <div class="d-block">
                <h5>Tanggal Pelaksanaan</h5>
                <p class="ml-3 text-muted">26 - 29 Maret 2020</p>
              </div>
              <div class="d-block">
                <h5>Kota/Kab</h5>
                <p class="ml-3 text-muted">Jakarta</p>
              </div>
              <div class="d-block">
                <h5>ALamat</h5>
                <p class="ml-3 text-muted">IAPI Pusat Korwil Jakarta</p>
              </div>
              <div class="d-block">
                <h5>Biaya</h5>
                <div class="row ml-3">
                  <div class="col-12">
                    <p class="mb-0">Anggota AP : Rp. 500.000,</p>
                    <p class="mb-0 text-muted">Anggota Non AP : Rp. 700.000</p>
                    <p class="mb-0 text-muted">Anggota Umum Rp. 800.000</p>
                  </div>
                </div>
              </div>
              <div class="d-block mt-3">
                <h5>Perolehan SKP</h5>
                <div class="col-12">
                  <p class="font-weight-bold mb-0">SKP IAPI</p>
                  <p class="ml-3 mb-0 text-muted">Terstruktur : 30</p>
                  <p class="ml-3 mb-0 text-muted">Tidak Terstruktur : 15</p>
                  <p class="ml-3 mb-0 text-muted">Assesment : 20</p>
                </div>
                <div class="col-12 mt-2">
                  <p class="font-weight-bold mb-0">SKP Non IAPI</p>
                  <p class="ml-3 mb-0 text-muted">Terstruktur : 30</p>
                  <p class="ml-3 mb-0 text-muted">Tidak Terstruktur : 15</p>
                </div>
              </div>
              <div class="d-block mt-3">
                <h5>Jumlah Kursi</h5>
                <p class="ml-3 text-muted">100</p>
              </div>
              <div class="d-block mt-3">
                <h5>Sisa Kursi</h5>
                <p class="ml-3 text-muted">23</p>
              </div>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Detail</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
      <!-- Modal detail -->
      <ModalDetailWebinar 
        :modalDetailPelatihanOnline="modalDetailPelatihanOnline"
        :formData="formData"
      />
      <!-- End Modal -->
    </CCardBody>

</template>
<script>
import WorkshopService from "../../../services/pelatihan/workshop.service";
import BaseUrl from "../../../services/base-url";
import { AlertUtils } from "../../../mixins/AlertUtils";
import { Pagination } from "../../../mixins/Pagination";

import ModalDetailWebinar from "./ModalDetailWebinar"

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "flyer",
    sorter: true,
    label: "Flyer Pelatihan",
    _style: 'width: 10%',
    sorter: true,
    filter: false
  },
   {
    sorter: true,
    key: "no_laporppl",
    label: "Nomor Lapor Pelatihan",
    _style: 'width: 13%',
    sorter: true,
    filter: false
  },
  {
    key: "nama_ppl",
    label: "Nama Pelatihan ",
    sorter: true,
    filter: false
  },
  
  {
    key: "tgl_pelaksanaan",
    label: "Tanggal Pelaksanaan",
    sorter: true,
    filter: false
  },
  {
    key: "skp_terstruktur",
    label: "SKP Terstruktur",
    sorter: true,
    _style:"text-align:center",
    filter: false
  },
  {
    _style:"text-align:center",
    key: "skp_non_terstruktur",
    label: "SKP Non Terstruktur",
    sorter: true,
    filter: false
  },
  {
    key: "assessment",
    _style:"text-align:center",
    label: "SKP Asessment",
    sorter: true,
    filter: false
  },
  {
    key: "_status",
    label: "Status Aktif",
    _style: "text-align: center",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "text-align: center;",
    sorter: false,
    filter: false
  }
];

export default {
  mixins: [AlertUtils, Pagination],
  name: "Workshop",
  data() {
    return {
      items: [],
      modalDetailPelatihanOnline : false,

      formFilter: {
        tahun: new Date().getFullYear()
      },
     
      formData: {
        deskripsi: "",
        file: "",
        id_user: "",
        id_workshop_pelatihan: ""
      },
      fileName: "Choose File...",
      fields,
      currentPage: 0,
      details: [],
      pagination: {
        totalPages: 0
      },
      no: 1,
      pageSize: "",
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: [],
      dataTahun: [],
      role_status: null,
      
    };
  },
  mounted() {
    this.baseUrl = BaseUrl();
    this.getData("0", this.pageSize, "default");
    this.getTahun();
    this.roleData();
  },
  watch: {
    multi_user: function(val) {
      this.formData.idUser = val.id_user;
    },
    currentPage: function(val) {
      //alert val -1
      var page = val - 1;
      this.indexed = page * 10;
      this.getData(val - 1, this.pageSize, this.search);
    }
  },
  components : {
    ModalDetailWebinar
  },
  methods: {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === '/pelatihan/daftar-pelatihan/webinar' );  
      this.role_status = data;
    },
    getTahun() {
      for (let index = 0; index < 10; index++) {
        this.dataTahun.push(2018+index)
      }
    },
    imgError(e) {
      e.target.src = '/img/placeholder-image.png'
    },
    tutupModal() {
      this.modalDetailPelatihanOnline = false
    },
    lihatDetail(item) {
      this.modalDetailPelatihanOnline = true
      this.formData = item;
    },
    formatTimestamp(item) {
      moment.locale('id')
      return moment(item).format("DD-MMMM-YYYY")
    },
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },
    cariData() {
      this.getData("0", this.pageSize, this.search);
    },
    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search);
    },
    pilihTahun(e) {
      this.formFilter.tahun = e.target.value
      this.getData("0", this.pageSize, this.search);
    },
    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      }); 

      WorkshopService.getWebinar(currentPage, pageSize, filter, this.formFilter.tahun)
        .then(response => {
          loader.hide();
          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
         
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },
    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            WorkshopService.deleteWorkshop(this.formData)
              .then(response => {
                this.alertDeleteSuccess()
                this.getData("0", this.pageSize, this.search);
                this.$emit('updateCounter','counter')
              })
              .catch(error => {
                this.alertError(error.response.data.message);
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    }
  }
};
</script>